import { useMemo } from 'react'
import { ifcRootGuid } from '@constants'
import { useProjectFiles } from '.'
import type { IfcModelMetadata } from '../../components/Controls/IFCUploadWidget/types/ifcMetadata'

/**
 * Returns IFC model metadata (property_data with MGroup etc.) for the given GLB file guid.
 * Metadata is stored in the GLB file's additional_data.model_metadata (from core-v2).
 */
function useIfcModelMetadata(activeIfcFileGuid: string | null): IfcModelMetadata | null {
  const { data: filesData } = useProjectFiles(ifcRootGuid)

  return useMemo(() => {
    if (!activeIfcFileGuid || !filesData?.files) return null
    const file = filesData.files.find(
      (f: FileItem) =>
        f.guid === activeIfcFileGuid &&
        (f.mimetype === 'application/glb' ||
          f.mimetype === 'model/gltf-binary' ||
          f.mimetype === 'application/octet-stream'),
    )
    const additional = file?.additional_data as { model_metadata?: IfcModelMetadata } | undefined
    return additional?.model_metadata ?? null
  }, [activeIfcFileGuid, filesData?.files])
}

export default useIfcModelMetadata
